import Base64Support from './Base64Support';

export default class ServerBase64Support extends Base64Support {
  encode(value: string): string {
    return Buffer.from(value, 'utf-8').toString('base64');
  }

  decode(value: string): string {
    return Buffer.from(value, 'base64').toString('utf-8');
  }
}
